module.exports = __webpack_public_path__ + "static/media/Introducing ISO 19650 Naming Convention Builder for BIM 360 CDE.fa406b00.jpeg";